import KYC from './kyc';

export default KYC;



// WEBPACK FOOTER //
// ./src/components/cards/kyc/index.js